import { http } from 'services/http';
import { INVOICES_GET_MANY, INVOICES_GET_ONE } from 'api/query-keys.ts';
import type { SyncInvoicesToInfaktReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

export const useSyncInvoicesToInfakt = () => {
  return useMutationBase<void, unknown, SyncInvoicesToInfaktReq>({
    mutationFn: async (variables) => {
      await http.post('/v1/invoices/sync-infakt', variables);
    },

    invalidateCallback: (_data, variables) => [[INVOICES_GET_ONE, variables.invoiceIds[0]], [INVOICES_GET_MANY]],
  });
};
